module.exports = __webpack_public_path__ + "static/media/acquaintances.5d307141.svg";